import { ReactNode, useEffect } from 'react';
import { useRouter } from 'next/router';
import { useSelector } from 'react-redux';

import { PublicRoutePath } from '../../../../utils/routes';
import { authenticated$ } from '../../../../store/session/selectors';

interface PrivateRouteProps {
  children: ReactNode;
}

function PrivateRoute({ children }: PrivateRouteProps) {
  const authenticated = useSelector(authenticated$);
  const { push } = useRouter();

  useEffect(() => {
    if (!authenticated) void push(PublicRoutePath.HOME);
  }, [authenticated, push]);

  return <>{children}</>;
}

export default PrivateRoute;
